<template>
  <div
    id="element"
    class="home_page h-full"
  >
    <theHeader class="headd" />

    <div class="pt-20 mt-2">
      <router-view :scroll="scrollSteep" />
    </div>

    <footMenu @scroll="retourScroll" />
  </div>
</template>

<script>
import theHeader from '@/components/header2'
import footMenu from '@/components/footMenu'

export default {
  name: 'Home',
  components: {
    theHeader,
    footMenu
  },
  data () {
    return {
      scrollSteep: null
    }
  },
  mounted () {
    this.smooth()
  },
  methods: {
    smooth () {
      let element = document.getElementById('element')
      // element.scrollIntoView(true)
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    },
    retourScroll (answer) {
      this.scrollSteep = answer
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/style/sass/variables";
.headd{
  position: fixed;
  width: 100%;
}
  .home_page {
    background-color: #f8f8f8;
    width: 100%;
  }
  .home_page::-webkit-scrollbar {
    display: none;
  }
.home_page{
  overflow: hidden;
}
</style>
